import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import {
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@material-ui/core'
import { Modal } from '../../common/Modal'

export const CreateProductModal = ({
    availableAppList,
    setModalOpen,
    okMethod,
}) => {
    const [formState, setFormState] = useState({
        appId: null,
        url: null,
    })

    const formStateSet = () => {
        return !Object.keys(formState).every(
            key => formState[key] !== null && formState[key] !== ''
        )
    }

    const createForm = () => {
        return (
            <Grid>
                <FormControl>
                    <InputLabel required={true}>App</InputLabel>
                    <Select
                        value={formState.appId}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                appId: val,
                            })
                        }}>
                        {availableAppList.map(x => {
                            return <MenuItem value={x.id}>{x.value}</MenuItem>
                        })}
                    </Select>
                </FormControl>

                <FormControl>
                    <TextField
                        required={true}
                        label={'Url'}
                        onChange={e => {
                            const val = e.target.value
                            setFormState({
                                ...formState,
                                url: val,
                            })
                        }}
                    />
                </FormControl>
            </Grid>
        )
    }

    return (
        <Modal
            data-testid='create-product-modal'
            title='Add New Product'
            cancelText='Close'
            okText='Add'
            okMethod={() => okMethod(formState)}
            openModal={setModalOpen}
            isOkDisabled={formStateSet()}
            maxWidth='md'
            fullWidth={true}>
            {createForm()}
        </Modal>
    )
}
